var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDummyUser1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.800049C9.40005 0.800049 0.800049 9.40005 0.800049 20C0.800049 30.6 9.40005 39.2001 20 39.2001C30.6 39.2001 39.2001 30.6 39.2001 20C39.2001 9.40005 30.6 0.800049 20 0.800049ZM20 35.6C12.5 35.6 6.50005 32.1 6.50005 27.8C6.50005 23.5 12.5 20 20 20C15.7 20 12.2 16.5 12.2 12.2C12.2 7.90005 15.7 4.40005 20 4.40005C24.3 4.40005 27.8 7.90005 27.8 12.2C27.8 16.5 24.3 20 20 20C27.5 20 33.5 23.5 33.5 27.8C33.5 32.1 27.5 35.6 20 35.6Z",
    fill: "#FB607F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummyUser1);
export default __webpack_public_path__ + "static/media/dummy-user 1.6ab3712522ecbc1a55da6f1af431dce7.svg";
export { ForwardRef as ReactComponent };